namespace TabAurous.ECommerce {
    export interface OrderReceiptForm {
        ModeId: Serenity.LookupEditor;
        LedgerId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        RefNo: Serenity.StringEditor;
        Scheme: Serenity.LookupEditor;
        BankId: Serenity.LookupEditor;
        ChequeNo: Serenity.IntegerEditor;
        ChequeDate: Serenity.DateEditor;
    }

    export class OrderReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.OrderReceipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderReceiptForm.init)  {
                OrderReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;

                Q.initFormType(OrderReceiptForm, [
                    'ModeId', w0,
                    'LedgerId', w0,
                    'Amount', w1,
                    'RefNo', w2,
                    'Scheme', w0,
                    'BankId', w0,
                    'ChequeNo', w3,
                    'ChequeDate', w4
                ]);
            }
        }
    }
}
